<template>
  <div class="page-try-m">
    <div class="try-banner">
      <div class="try-form-wrap ui-flex ui-flex-justify-center ui-flex-align-center">
        <div class="try-form">
          <div class="form-title">申请即可开通渝神缘智能燃气平台，无多余审核程序</div>
          <div class="form-tips">最多可获得终身免费使用权</div>
          <div class="form-item">
            <input class="form-item-input" type="text" ref="companyName" placeholder="公司全称">
          </div>
          <div class="form-item">
            <input class="form-item-input" type="text" ref="customerName" placeholder="姓名">
          </div>
          <div class="form-item">
            <input class="form-item-input" type="text" ref="mobile" placeholder="手机">
          </div>
          <div class="form-item">
            <input class="form-item-input form-item-code" ref="code" type="text" placeholder="验证码">
            <span class="form-item-btn" @click="sendCode">{{sendCodeWord}}</span>
          </div>

          <div class="form-btn" @click="applyTry">申请试用</div>
          <div class="form-back ui-flex ui-flex-justify-center ui-flex-align-center" @click="jump('/index_m')">
            <span class="form-back-content" >返回首页</span>
            
          </div>
        </div>
      </div>

    </div>



  </div>

</template>
<script>
  import SERVER from '@/config/config.ts'
  import URL from '@/config/server.ts'
  import { Toast  } from 'mint-ui';
  import router from '@/router'
  import axios from 'axios'
  import qs from 'qs'
  export default {
    data() {
      return {
        sendCodeWord: '点击发送验证码',
        count: 60,
        isClick: true,
      }
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    beforeCreate(){
      require('../../../static/js/adaptation.js')
    },
    methods: {
      /**
       * 点击跳转
      */
      jump(value) {
        router.push({
          path: value,
        }).catch(err => {
          console.log(err)
        })

      },
      /**
       * 发送验证码
      */
      sendCode() {
        axios.post(SERVER.EBASE_URL+URL._ow_api_captcha_sms_code, {
          captchaInfo: {
            captchaType: 'OW_APPLY',
            code: this.$refs.code.value,
            mobile: this.$refs.mobile.value,
          }
        }).then((response) => {
          if (response.data.executed) {
          
            Toast('发送成功');
            this.countDown();
          } else {
            
            Toast(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });

      },
      /* 
      * 倒计时
      */
      countDown() {
        if (this.isClick) {
          this.isClick = false;
          this.sendCodeWord = this.count + 's';
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            if (this.count > 1) {
              this.count--;
              this.sendCodeWord = this.count + 's';
            } else {
              this.sendCodeWord = '点击发送验证码';
              clearInterval(this.timer)
              this.isClick = true;
            }

          }, 1000);
        }

      },
      /**
     * 申请试用
    */
      applyTry() {
        axios.post(SERVER.EBASE_URL+URL._ow_api_save_apply, {
          captcha: this.$refs.code.value,
          saveApplyInfo: {
            companyName: this.$refs.companyName.value,
            customerName: this.$refs.customerName.value,
            mobile: this.$refs.mobile.value,
          }
        }).then(function (response) {
          if (response.data.executed) {
            Toast( '申请成功,请等待工作人员与您联系。');
            
          } else {
           
            Toast( response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }

    },

  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>